import ClothingStore from "./components/ClothingStore";

export default ClothingStore;
